import * as React from "react";
import SidebarItem from "../../Generics/SidebarItem";
import { faintBlue } from "../../Generics/_colors";
import { Gray20 } from "@traceair/tds";

interface IFlightMarkerItemProps {
  id: string;
  name: string;
  icon: React.ReactNode;
  isActive: boolean;
  onClick: () => void;
}

export const FlightMarkerItem = ({
  name,
  icon,
  isActive,
  onClick,
}: IFlightMarkerItemProps) => (
  <SidebarItem
    backgroundColor={isActive ? faintBlue : "#FFFFFF"}
    borderBottomColor={Gray20}
    leftIcon={icon}
    leftLabel={name}
    onLeftIconClick={onClick}
    onLeftLabelClick={onClick}
    onRightLabelClick={onClick}
    onRightIconClick={onClick}
  />
);
